import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Maksutavat',
  payment_options: {
    [PaymentMethod.Card]: 'Luottokortti',
  },
};
